function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoQatarTourism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.67 282.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M189.64,115.43c0-5.18,3-9.5,8-16.62,5.82-8.63,15.75-22,23.73-29.12a25.61,25.61,0,0,1,1.51,9.06c0,15.32-9.92,36-27.4,51.13C192,124.7,189.64,120.39,189.64,115.43ZM35.17,201.08l.21-.22Zm261.49,17a72.13,72.13,0,0,0,9.92-.64,14.82,14.82,0,0,0,4.75-10.58c0-6.68-4.75-9.49-11.22-9.49h-3.45Zm-11,23.95V192.88h15.54c14,0,21.14,5.83,21.14,13.81,0,6.47-4.31,10.14-9.06,12.94l13.16,22.44H314.35L302.7,222.22a52.17,52.17,0,0,1-6,.43v19.42ZM227.83,227.4h17.26l-8.63-23.08C233.44,212.08,230.64,219.63,227.83,227.4Zm-11.65,14.67c7.12-15.75,13.38-31.07,20.71-49.19h6.69l18.56,49.19H250.49l-3.89-10.35H226.32l-3.45,10.35ZM159,200l2.16-7.12h41L200,200c-5-1.94-9.92-3.67-13.81-3.88v45.95H175V196.12C170.87,196.33,164,198.06,159,200ZM109,227.4h17.26l-8.41-22.65C114.78,212.3,111.76,219.85,109,227.4ZM97.3,242.07c7.12-15.75,13.6-31.28,20.72-49.19h6.68l18.56,49.19H131.61l-3.89-10.35H107.44L104,242.07Zm-60-25.89c0,16.18,6.26,22,15.75,22a20.31,20.31,0,0,0,5-.43c2.15-4.1,3.66-9.71,3.66-18.77,0-16.62-6.25-22.23-15.53-22.23a16.48,16.48,0,0,0-4.53.65C39.05,201.08,37.32,206.47,37.32,216.18Zm-11.43,2.38c0-17.26,12.73-26.33,24.16-26.33,9.93,0,23.09,6.26,23.09,24,0,10.79-5.39,20.5-14.46,24.6,6.05,3,13.16,6.47,16,7.12A27.55,27.55,0,0,0,81.77,249a17.81,17.81,0,0,0,2.8-.22l.44.86c-1.73,1.51-7.77,5.18-12.09,5.18a15.6,15.6,0,0,1-9.27-3.23l-12.3-9.07a13.24,13.24,0,0,1-2.59.22C38.19,242.72,25.89,236.25,25.89,218.56ZM0,157.71c8.63,6.48,20.5,12.52,34.52,12.52,25.46,0,34.3-20.93,42.72-51.35,10.79,25.89,29.56,48.76,66.88,48.76,22.66,0,39.7-8.42,52.21-20.28,8.85,9.49,25.89,22.87,56.31,22.87,57.61,0,77-51.78,77-76.59,0-11-3-17.26-8.2-17.26-5.83,0-9.06,6.9-9.06,14.45,0,7.34,3.23,10.36,7.12,10.36a7.44,7.44,0,0,0,5.17-1.73,10.31,10.31,0,0,1,.22,2.59c0,16.18-22.65,49.41-72.28,49.41-19.63,0-35.6-5-48.11-12.73,15.75-19.85,22-45.31,22-59.77,0-10.14-2.81-26.1-6-30.63-2.16,3.23-5.83,8-12.09,16-6.68,8.42-9.06,11.65-12.29,16.83a103.57,103.57,0,0,0,2.15-22.22c0-25.89-9.7-47-16.82-58.9h-.87l-6.69,20.06c11.22,20.29,18.56,38.19,18.56,51.57,0,15.75-6.47,25.67-6.47,46.17,0,8.41,1.08,13.59,2.37,17.48a77.24,77.24,0,0,1-44,13.59c-44.66,0-63.43-29.34-72.71-71h-.86l-3,10.35a218.52,218.52,0,0,0,7.12,24.38c-4.1,19.85-27.62,47.9-53.29,47.9-6.48,0-14.46-1.73-21.15-3.67Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.76,89.54l.21-.87a39.91,39.91,0,0,0,7.34.44c19.2,0,43.15-7.77,52.21-16.83h.86a9.19,9.19,0,0,1,1.51,5.61c0,11.86-15.53,17.9-33.44,17.9C119.31,95.79,108.52,93.85,100.76,89.54Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,85.65l13.81,12.52,7.55-11.65,12.95,11.65,9.27-14.46a78.66,78.66,0,0,0-14-12.08A39.58,39.58,0,0,0,280,82.42a80.12,80.12,0,0,0-12.73-10.79C263.43,75.3,259.12,82.42,258.25,85.65Z",
    style: {
      fill: "#bf4f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.27,280.26a2.08,2.08,0,0,0-2.17-2.17,2.12,2.12,0,0,0-2.17,2.17,2.17,2.17,0,0,0,4.34,0Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,278.09a2.13,2.13,0,0,0-2.17,2.17,2.17,2.17,0,1,0,2.17-2.17Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.87,256.91a2.06,2.06,0,0,0,2.17-2.09,2.08,2.08,0,0,0-2.17-2.17,2.12,2.12,0,0,0-2.17,2.17A2.06,2.06,0,0,0,230.87,256.91Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.9,274.73c1,0,2.09-.23,4.41-1.5a7.83,7.83,0,0,0,5.31,1.5h4.79l.15-21.86-3.44.23.82,18.26h-2.39a7.36,7.36,0,0,1-4-1l.15-17.52-3.44.23.52,18.26h-3.37a3.72,3.72,0,0,1-2.32-.82,46.6,46.6,0,0,0-.52-7.71l-3.3.22a36.45,36.45,0,0,1,1.2,8.31,11.61,11.61,0,0,1-4.94-.82,25.32,25.32,0,0,0-.75-6.52l-3.21.23a31.35,31.35,0,0,1,1.27,7.11,10.93,10.93,0,0,1-4.79-.82c-.23-1.35-.3-3.52-.75-5.24l-3.07.22a28.85,28.85,0,0,1,1,5.84h-3.51a6.35,6.35,0,0,1-3.45-1.12c0-.15.08-.53.08-1.13a28.47,28.47,0,0,0-.45-6.43l-3.29.22a66.81,66.81,0,0,1,1.12,8.38c-1.35.08-2.69.08-4,.08h-6.84l.15-18.49-3.37.23.9,21.63h8.33a10.69,10.69,0,0,0,6.37-1.5c1.12,1,2.69,1.5,5.31,1.5a7,7,0,0,0,4.71-1.57,4.18,4.18,0,0,0,3.15,1.57,9.41,9.41,0,0,0,4.56-1.57,4.15,4.15,0,0,0,3.07,1.57c1.27,0,2.55-.53,4.57-1.57A3.87,3.87,0,0,0,310.9,274.73Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,256.91a2.05,2.05,0,0,0,2.17-2.09,2.08,2.08,0,0,0-2.17-2.17,2.13,2.13,0,0,0-2.17,2.17A2.06,2.06,0,0,0,225.63,256.91Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.31,268.07v-2.4c-4.19,0-9.13-3.07-12.57-3.07a6.62,6.62,0,0,0-4.94,1.8v2a16.67,16.67,0,0,1,3.82-.6c3.81,0,5.38,2.1,11.22,2.1-2.77,1.64-10.33,3.44-20.8,3.44h-6.4c-2.09,0-2.69-.67-2.69-2.47v-9.58h-2.7v2.47c-4.34.52-8.38,4.12-8.38,8.91,0,2.69,1.42,4.34,4,4.34a5.52,5.52,0,0,0,4.65-3.09c.42,1.85,1.73,2.79,4,2.79h8.34v0C249.74,274.58,260,272.35,263.31,268.07Zm-35.06,1.49a4.17,4.17,0,0,1-3.74,1.72c-1,0-2.47-.3-2.47-1.94,0-1.27,1.87-3.82,6.21-4.34Z",
    style: {
      fill: "#8d1737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.66,252.37a2.08,2.08,0,1,0,2.11,2.11A2.1,2.1,0,0,0,164.66,252.37Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.48,259.17c-4.63,0-7.42,2.79-7.42,8.1,0,5.1,2.52,7.89,6.8,7.89,4.63,0,7.42-2.79,7.42-8.09C129.28,262,126.76,259.17,122.48,259.17ZM124.65,273a5.3,5.3,0,0,1-2,.28c-3.06,0-4.08-3.41-4.08-6.47,0-2,.34-4.35,1.09-5.37a5.49,5.49,0,0,1,2-.27c3.06,0,4.08,3.33,4.08,6.39C125.74,269.58,125.4,272,124.65,273Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,266c-1.77-1-3.75-2.18-3.75-3.47a1.89,1.89,0,0,1,.21-.89,3.63,3.63,0,0,1,2-.41,15.43,15.43,0,0,1,4.76.82v-1.84a9.07,9.07,0,0,0-4.76-1.08c-3.61,0-5.65,1.83-5.65,4.35,0,2,2,3.61,4,4.83,1.63,1,3.67,2.31,3.67,4.15a5.93,5.93,0,0,1-3.13.61,23.56,23.56,0,0,1-4.9-.61v1.84a15.88,15.88,0,0,0,4.9.88c4.35,0,6-1.56,6-4.15C181.66,269.17,180.24,267.13,178.2,266Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,254.07H98.26l-1,3.06a24.75,24.75,0,0,1,7.42-1.28v19h3.54v-19a14.82,14.82,0,0,1,6.39,1.28Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.02,
    y: 259.65,
    width: 3.33,
    height: 15.24,
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11,259.65h-2.58v15.24h3.33V263.14a7.37,7.37,0,0,1,3.13-.56,12.27,12.27,0,0,1,2.31.27v-3.74a9.94,9.94,0,0,0-5.67,2.54Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.61,271.41a9.39,9.39,0,0,1-3.67,1.17c-1.63,0-2.45-1.16-2.45-2.93v-10h-3.33v10.41c0,3.33,1.83,5.17,4.56,5.17a8.22,8.22,0,0,0,5.12-2.33l.52,2H146V259.65h-3.34Z",
    style: {
      fill: "#005871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,259.31a8.44,8.44,0,0,0-5.39,2.6,4.17,4.17,0,0,0-4.07-2.6,8.19,8.19,0,0,0-5.12,2.33l-.53-2h-2.58v15.24H189V263.13a9.39,9.39,0,0,1,3.68-1.17c1.63,0,2.45,1.16,2.45,2.93v10h3.33V264.48a8.64,8.64,0,0,0-.11-1.3,8.57,8.57,0,0,1,3.78-1.22c1.64,0,2.45,1.16,2.45,2.93v10h3.34V264.48C207.93,261.15,206.09,259.31,203.37,259.31Z",
    style: {
      fill: "#005871"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoQatarTourism);
export default __webpack_public_path__ + "static/media/logo-qatar-tourism.409a66234d640f295fb9ff17e66740a8.svg";
export { ForwardRef as ReactComponent };